import {
  RenderDayOfWeekProps,
  RenderDayProps,
  RenderOtherMonthProps,
  RenderWeekProps,
} from "components/month_renderer";
import { Spacer } from "components/spacer";
import { Text } from "components/text_v2";
import { tokens } from "components/tokens";
import { format } from "date-fns";
import React, { Fragment } from "react";
import { View, Pressable, StyleSheet } from "react-native";

interface DayViewProps {
  day: Date;
  withinSelected: boolean;
  selected: boolean;
  selectedStart: boolean;
  selectedEnd: boolean;
  today: boolean;
  outsideRange: boolean;
  blocked: boolean;
  onSelect: (day: Date) => void;
}

export function DayView(props: DayViewProps) {
  const {
    day,
    withinSelected,
    selected,
    selectedStart,
    selectedEnd,
    today,
    outsideRange,
    blocked,
    onSelect,
  } = props;

  if (outsideRange || blocked) {
    return (
      <View style={styles.dayRoot}>
        <View style={styles.dayWrapper}>
          <Text decoration="line-through" color="black-30" size="xs">
            {format(day, "d")}
          </Text>
        </View>
      </View>
    );
  }

  return (
    <View style={[styles.dayRoot, withinSelected && styles.withinSelected]}>
      <Pressable
        testID={`date-picker-day-button-${format(day, "MM-dd")}`}
        onPress={() => onSelect(day)}
        style={styles.dayButton}
      >
        {({ hovered }: { hovered: boolean }) => (
          <Fragment>
            {selectedStart && !selectedEnd && (
              <View style={[styles.selectedEdge, styles.selectedStart]} />
            )}
            {selectedEnd && !selectedStart && (
              <View style={[styles.selectedEdge, styles.selectedEnd]} />
            )}
            <View
              style={[
                styles.dayWrapper,
                hovered && styles.hoveredDay,
                selected && styles.selectedDay,
              ]}
            >
              <Text color={selected ? "white-core" : "black-core"} size="xs">
                {format(day, "d")}
              </Text>
              {today && <View style={styles.todayMarker} />}
            </View>
          </Fragment>
        )}
      </Pressable>
    </View>
  );
}

export function renderDay(p: RenderDayProps, onSelect: (day: Date) => void) {
  return <DayView {...p} onSelect={onSelect} />;
}

interface OtherMonthDayProps {
  withinSelected: boolean;
  day: Date;
}

export function OtherMonthDay(props: OtherMonthDayProps) {
  const { withinSelected } = props;

  return (
    <View style={[styles.dayRoot, withinSelected && styles.withinSelected]} />
  );
}
export function renderOtherMonthDay(p: RenderOtherMonthProps) {
  return <OtherMonthDay {...p} />;
}

interface DayOfweekProps {
  date: Date;
}

export function DayOfWeek(props: DayOfweekProps) {
  const { date } = props;

  return (
    <Text color="black-70" size="micro">
      {/* {format(date, "EEEEEE")} */}
      {format(date, "EEE").toUpperCase()}
      <Spacer size={8} direction="column" />
    </Text>
  );
}

export function renderDayOfWeek(p: RenderDayOfWeekProps) {
  return <DayOfWeek {...p} />;
}

interface WeekProps {
  children: React.ReactNode;
}

export function Week(props: WeekProps) {
  const { children } = props;

  return <View style={styles.week}>{children}</View>;
}

export function renderWeek(p: RenderWeekProps) {
  return <Week {...p} />;
}

const styles = StyleSheet.create({
  dayRoot: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  dayButton: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
    padding: 0,
  },
  dayWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: 999,
    justifyContent: "center",
    textAlign: "center",
    height: 28,
    width: 28,
  },
  withinSelected: {
    backgroundColor: "rgba(82,68,134,0.15)",
  },
  todayMarker: {
    position: "absolute",
    bottom: 2,
    width: 4,
    height: 4,
    paddingTop: 4,
    borderRadius: 999,
    backgroundColor: "black",
  },
  selectedEdge: {
    backgroundColor: "rgba(82,68,134,0.15)",
    position: "absolute",
    zIndex: -1,
    width: "50%",
    right: 0,
    height: "100%",
  },
  selectedStart: {
    right: 0,
  },
  selectedEnd: {
    left: 0,
  },
  week: {
    paddingTop: 2,
    paddingBottom: 2,
  },
  selectedDay: {
    backgroundColor: tokens.colors.primary.light,
  },
  hoveredDay: {
    borderWidth: 1,
    borderColor: tokens.colors.primary.light,
  },
});
